module.exports = "/_next/static/images/ImproveYourAds-00372b3afbeb16b8bd03920a4bb6c9c1.webp";